import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { StudyLocalizationStatus } from '@axon/rosetta-sdk';
import { JobTypes } from 'libs.jobs.common';
import { useJobs } from 'libs.jobs.react';
import { LocalizationStatus } from 'libs.localization.common';
import { useLocalization } from 'libs.localization.react';
import { Locale, useLocalizeMessage, Spinner } from 'libs.nucleus';
import { TranslationWorkbenchContext } from '../../contexts';
import { useAssetContext } from '../../hooks/use_asset_context.hook';
import { VersionedTableImport } from '../import_table/versioned_table_import.component';
import { EmptySection } from '../section_empty';
export const SectionImport = ({ asset }) => {
    const translate = useLocalizeMessage();
    const { localizationEntry, isLoading, localization } = useLocalization(asset);
    const { getAssetByTranslationWorkbenchId, studyLocalizationStatus } = useContext(TranslationWorkbenchContext);
    const isStudyInDraft = studyLocalizationStatus !== StudyLocalizationStatus.READY;
    const { getReviewUrl } = useAssetContext();
    const assetId = localization?.getId() ?? '';
    const assetLocaleData = getAssetByTranslationWorkbenchId?.(assetId);
    const { values: aiTranslationJobs } = useJobs({
        type: [
            JobTypes.TRANSLATION__GENERATE_TRANSLATION,
            JobTypes.TRANSLATION__INSTANT_MIGRATION,
            JobTypes.TRANSLATION__ASSET_IMPORT_SERVICE,
        ],
        asset_id: assetId,
    });
    const availableLocales = useMemo(() => {
        if (!localization?.getId()) {
            return [];
        }
        if (!assetLocaleData) {
            return [];
        }
        return assetLocaleData?.currentVersionStatus
            ? Object.entries(assetLocaleData.currentVersionStatus)
                .filter(([locale, status]) => locale !== Locale.en_US && status?.status !== LocalizationStatus.NOT_AVAILABLE)
                .map(([locale]) => locale)
            : [];
    }, [localization, getAssetByTranslationWorkbenchId, assetLocaleData]);
    const data = useMemo(() => availableLocales.map((locale) => {
        const { last_updated, status } = localizationEntry?.supported_locales?.[locale] || {};
        return {
            locale: locale,
            status: status,
            last_updated: last_updated ? last_updated.toDate().toISOString() : '',
            version: '', // will be deprecated
            reviewPath: `${getReviewUrl()}/${locale}?assetType=${asset?.type}`,
            latestVersionStatus: assetLocaleData?.latestVersionStatus?.[locale],
            currentVersionStatus: assetLocaleData?.currentVersionStatus?.[locale],
        };
    }), [availableLocales]);
    if (data.length || aiTranslationJobs?.length) {
        // return <TableImport data={data} />;
        // Note: Duplicated in case this need to put behind a developer flag
        return _jsx(VersionedTableImport, { data: data, hasOptions: true, asset: asset, isStudyInDraft: isStudyInDraft });
    }
    if (isLoading) {
        return _jsx(Spinner, { wrapper: 'full' });
    }
    return _jsx(EmptySection, { text: translate('Translations will appear here') });
};
